/* ui/tournament/TournamentResults.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text,
	toggle_class
} from "svelte/internal";

import { playerOneStore, playerTwoStore } from "../../stores/player_store";
import { resultsStore } from "./tournament_store";

function add_css() {
	var style = element("style");
	style.id = "svelte-30tydk-style";
	style.textContent = ".oneScore.svelte-30tydk{color:#e80000}.twoScore.svelte-30tydk{color:#00838f}.winner.svelte-30tydk{font-weight:bold}div.svelte-30tydk{display:grid;grid-template-columns:350px 1em;grid-gap:5px}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div;
	let label0;
	let t0_value = /*$playerOneStore*/ ctx[2].displayName + "";
	let t0;
	let t1;
	let t2;
	let data0;
	let t3_value = /*$resultsStore*/ ctx[1][0] + "";
	let t3;
	let t4;
	let label1;
	let t5_value = /*$playerTwoStore*/ ctx[3].displayName + "";
	let t5;
	let t6;
	let t7;
	let data1;
	let t8_value = /*$resultsStore*/ ctx[1][1] + "";
	let t8;
	let t9;
	let label2;
	let t11;
	let data2;
	let t12_value = /*$resultsStore*/ ctx[1][2] + "";
	let t12;

	return {
		c() {
			div = element("div");
			label0 = element("label");
			t0 = text(t0_value);
			t1 = text(":");
			t2 = space();
			data0 = element("data");
			t3 = text(t3_value);
			t4 = space();
			label1 = element("label");
			t5 = text(t5_value);
			t6 = text(":");
			t7 = space();
			data1 = element("data");
			t8 = text(t8_value);
			t9 = space();
			label2 = element("label");
			label2.textContent = "Ties:";
			t11 = space();
			data2 = element("data");
			t12 = text(t12_value);
			attr(label0, "class", "oneScore svelte-30tydk");
			toggle_class(label0, "winner", /*winnerIndex*/ ctx[0] === 0);
			attr(label1, "class", "twoScore svelte-30tydk");
			toggle_class(label1, "winner", /*winnerIndex*/ ctx[0] === 1);
			attr(label2, "class", "svelte-30tydk");
			toggle_class(label2, "winner", /*winnerIndex*/ ctx[0] === 2);
			attr(div, "class", "svelte-30tydk");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label0);
			append(label0, t0);
			append(label0, t1);
			append(div, t2);
			append(div, data0);
			append(data0, t3);
			append(div, t4);
			append(div, label1);
			append(label1, t5);
			append(label1, t6);
			append(div, t7);
			append(div, data1);
			append(data1, t8);
			append(div, t9);
			append(div, label2);
			append(div, t11);
			append(div, data2);
			append(data2, t12);
		},
		p(ctx, [dirty]) {
			if (dirty & /*$playerOneStore*/ 4 && t0_value !== (t0_value = /*$playerOneStore*/ ctx[2].displayName + "")) set_data(t0, t0_value);

			if (dirty & /*winnerIndex*/ 1) {
				toggle_class(label0, "winner", /*winnerIndex*/ ctx[0] === 0);
			}

			if (dirty & /*$resultsStore*/ 2 && t3_value !== (t3_value = /*$resultsStore*/ ctx[1][0] + "")) set_data(t3, t3_value);
			if (dirty & /*$playerTwoStore*/ 8 && t5_value !== (t5_value = /*$playerTwoStore*/ ctx[3].displayName + "")) set_data(t5, t5_value);

			if (dirty & /*winnerIndex*/ 1) {
				toggle_class(label1, "winner", /*winnerIndex*/ ctx[0] === 1);
			}

			if (dirty & /*$resultsStore*/ 2 && t8_value !== (t8_value = /*$resultsStore*/ ctx[1][1] + "")) set_data(t8, t8_value);

			if (dirty & /*winnerIndex*/ 1) {
				toggle_class(label2, "winner", /*winnerIndex*/ ctx[0] === 2);
			}

			if (dirty & /*$resultsStore*/ 2 && t12_value !== (t12_value = /*$resultsStore*/ ctx[1][2] + "")) set_data(t12, t12_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $resultsStore;
	let $playerOneStore;
	let $playerTwoStore;
	component_subscribe($$self, resultsStore, $$value => $$invalidate(1, $resultsStore = $$value));
	component_subscribe($$self, playerOneStore, $$value => $$invalidate(2, $playerOneStore = $$value));
	component_subscribe($$self, playerTwoStore, $$value => $$invalidate(3, $playerTwoStore = $$value));
	let winnerIndex;

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$resultsStore*/ 2) {
			$: $$invalidate(0, winnerIndex = $resultsStore.every(r => r === 0)
			? -1
			: $resultsStore.indexOf(Math.max(...$resultsStore)));
		}
	};

	return [winnerIndex, $resultsStore, $playerOneStore, $playerTwoStore];
}

class TournamentResults extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-30tydk-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default TournamentResults;